import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/home/solution/en_home_goldcircle.png'


const _withScopeId = n => (_pushScopeId("data-v-2492c32c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "committee-box" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"home-title\" data-v-2492c32c><div class=\"title\" style=\"display:flex;align-items:center;color:#000;margin:7px 0;\" data-v-2492c32c><img src=\"" + _imports_0 + "\" alt=\"\" data-v-2492c32c><div style=\"display:flex;flex-direction:column;\" data-v-2492c32c><p style=\"color:#000;font-size:1.5rem;margin-left:-15px;letter-spacing:2px;\" data-v-2492c32c>COMPANY IR CONTACT</p></div></div></div>", 1)
const _hoisted_3 = { class: "press-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#000","font-size":"1.2rem","font-weight":"600","margin-bottom":"20px"} }, "IR Dept.", -1))
const _hoisted_5 = ["item"]
const _hoisted_6 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center","gap":"10rem"} }
const _hoisted_7 = { style: {"color":"#000","font-size":"1rem","font-weight":"600","width":"40px"} }
const _hoisted_8 = { style: {"color":"#000","font-size":"1rem","max-width":"90%","font-weight":"600"} }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"home-title2\" data-v-2492c32c><div class=\"title\" style=\"display:flex;align-items:center;color:#000;margin:7px 0;\" data-v-2492c32c><img src=\"" + _imports_0 + "\" alt=\"\" data-v-2492c32c><div style=\"display:flex;flex-direction:column;\" data-v-2492c32c><p style=\"color:#000;font-size:1.5rem;margin-left:-15px;letter-spacing:2px;\" data-v-2492c32c>INVESTOR RELATIONS FIRM CONTACT</p></div></div></div>", 1)
const _hoisted_10 = { class: "press-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#000","font-size":"1.2rem","font-weight":"600","margin-bottom":"20px"} }, "Janice Wang", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#000","font-size":"1.2rem","font-weight":"600","margin-bottom":"20px"} }, "Wealth Financial Services LLC", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"margin":"2rem 0","border-top":"1px solid rgba(12, 106, 204, 0.2)"} }, null, -1))
const _hoisted_14 = ["item"]
const _hoisted_15 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center","gap":"10rem"} }
const _hoisted_16 = { style: {"color":"#000","font-size":"1rem","font-weight":"600","width":"40px"} }
const _hoisted_17 = { style: {"color":"#000","font-size":"1rem","max-width":"90%","font-weight":"600"} }

import Footer from "@/components/home/Footer.vue";
import { ref, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Contact',
  setup(__props) {

const datas = reactive([
  {
    label: "Email",
    name: "ir@91fd.com",
  },
  {
    label: "Phone",
    name: "+86-(21) 60901518",
  },
  {
    label: " Add ",
    name: "Units A-B, 15th Floor 180 Tianjin Road Huangpu District, Shanghai, 200001 People’s Republic of China",
  },
]);
const datas2 = reactive([
  {
    label: "Phone",
    name: "+86 13811768599 (from China), +1 628 283 9214 (from U.S.)",
  },
  {
    label: " Email ",
    name: "services@wealthfsllc.com",
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            item: item
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.label), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1)
            ]),
            _createElementVNode("hr", {
              style: _normalizeStyle([{"margin":"2rem 0","border-top":"1px solid rgba(12, 106, 204, 0.2)"}, {display: index === datas.length - 0 ? 'none' : ''}])
            }, null, 4)
          ], 8, _hoisted_5))
        }), 128))
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas2, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            item: item
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(item.label), 1),
              _createElementVNode("div", _hoisted_17, _toDisplayString(item.name), 1)
            ]),
            _createElementVNode("hr", {
              style: _normalizeStyle([{"margin":"2rem 0","border-top":"1px solid rgba(12, 106, 204, 0.2)"}, {display: index === datas.length - 0 ? 'none' : ''}])
            }, null, 4)
          ], 8, _hoisted_14))
        }), 128))
      ])
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})